import { X } from "lucide-react";
import { useFormatAmount } from "../../hooks/useFormatAmount";

const Chattel = ({ closeChattel, chattel }) => {
  const formatAmount = useFormatAmount();
  return (
    <div
      onClick={(e) => {
        closeChattel();
      }}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[850px] h-[600px] rounded-[10px] p-[20px] relative bg-white"
      >
        <div
          onClick={closeChattel}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#D63B3B] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>
        {/* Content */}
        <div className="bg-white p-5 w-full">
          <p className="text-[#000000] font-normal text-[16px] mb-[15px]">
            Chattel
          </p>
          {/* Header */}
          <div className="flex justify-between items-center mb-3">
            <h3 className="text-lg font-semibold text-[#222]">
              {chattel.name}
            </h3>
            <span className="text-sm bg-gray-100 px-3 py-1 rounded-full font-medium">
              {chattel.public_id}
            </span>
          </div>

          {/* Details Grid */}
          <div className="grid grid-cols-2 gap-4 text-sm mb-4">
            <div>
              <p className="text-gray-500">Location</p>
              <p className="font-medium">{chattel.location}</p>
            </div>
            <div>
              <p className="text-gray-500">Value</p>
              <p className="font-bold text-[#000000]">
                {formatAmount(chattel.value)}
              </p>
            </div>
            <div>
              <p className="text-gray-500">Condition</p>
              <p className="font-medium">{chattel.condition}</p>
            </div>
            <div>
              <p className="text-gray-500">Date Added</p>
              <p className="font-medium">
                {new Date(chattel.updatedAt).toLocaleDateString()}
              </p>
            </div>
            <div>
              <p className="text-gray-500">Last Updated</p>
              <p className="font-medium">
                {new Date(chattel.updatedAt).toLocaleDateString()}
              </p>
            </div>
          </div>

          {/* Description */}
          <div className="mb-4">
            <p className="text-gray-500 text-sm">Description</p>
            <p className="font-medium">{chattel.description}</p>
          </div>

          {/* Images Section */}
          <div>
            <p className="text-gray-500 text-sm mb-2">Images</p>
            {chattel.images?.length > 0 ? (
              <div className="flex flex-wrap gap-3">
                {chattel.images.map((img) => (
                  <div
                    key={img.id}
                    className="w-[150px] h-[120px] rounded-lg overflow-hidden border"
                  >
                    <img
                      src={img.imageUrl}
                      alt={chattel.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-gray-400 text-sm">
                No images available for this chattel
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Chattel;
